<!-- <div class="rounded-xl border border-card-contrast bg-card p-4">
  <div class="flex items-center justify-between pb-3">
    <div>
      <div class="text-sm text-foreground-secondary">Your appointment history</div>
      <div class="font-medium text-foreground">Recent Appointments</div>
    </div>
    <i class="pi pi-check-circle text-secondary-600"></i>
  </div>

  <div
    class="rounded-lg border border-card-contrast bg-card-elevated p-3 flex items-start gap-3 cursor-pointer hover:shadow-md hover:scale-105 transition-all ease-in"
    (click)="onClick()"
  >
    <div
      class="shrink-0 h-9 w-9 rounded-full bg-primary-100 dark:bg-primary-200/10 flex items-center justify-center text-primary-700 dark:text-primary-800"
    >
      <i class="pi pi-user"></i>
    </div>
    <div class="flex-1 min-w-0">
      <div class="font-medium text-foreground truncate">{{ item?.doctorName }}</div>
      <div class="text-sm text-foreground-secondary">{{ item?.title }}</div>
      <div class="text-xs text-foreground-tertiary flex items-center gap-3 mt-1">
        <span class="flex items-center gap-1"><i class="pi pi-calendar"></i>{{ item?.date }}</span>
      </div>
    </div>
    <span class="text-xs rounded-full px-2 py-1 bg-black text-white dark:bg-card-contrast">{{
      item?.status
    }}</span>
  </div>
</div> -->




<!-- tailwind  -->
 <!-- <div class="w-[370px] flex flex-col gap-4 shrink-0 mt-5 bg-[#e5e5e5] rounded-xl p-4 "> -->
  <!-- <h3 class="text-[1.2rem] text-center font-semibold text-[#333] mb-2">Recent</h3>

  <div
    class="bg-white rounded-2xl p-4 shadow-lg transition-transform hover:-translate-y-1 hover:shadow-xl dark:bg-gray-700"
    *ngFor="let appt of items"
  >
    <div class="flex justify-between items-center mb-2">
      <h3 class="m-0 font-semibold text-[1.1rem]">{{ appt.title }}</h3>
      <span
        class="text-[0.85rem] font-medium px-2.5 py-1 rounded-xl text-white"
        [ngClass]="{
          'bg-[#007aff]': appt.status.toLowerCase() === 'upcoming',
          'bg-[#34c759]': appt.status.toLowerCase() === 'completed',
          'bg-[#ff3b30]': appt.status.toLowerCase() === 'cancelled'
        }"
      >
        {{ appt.status }}
      </span>
    </div>

    <div>
      <p class="my-1 text-[0.95rem] "><strong>Doctor:</strong> {{ appt.doctorName }}</p>
      <p class="my-1 text-[0.95rem] "><strong>Date:</strong> {{ appt.date }}</p>
    </div>
  </div>
</div> -->





<div class="flex flex-col gap-4 shrink-0  rounded-xl p-4 dark:bg-[#1B3C53]">
  <h3 class="text-[1rem] font-semibold  mb-2">Recent Appointments</h3>

  <div 
    class="bg-white rounded-xl p-4 shadow-md transition-transform hover:-translate-y-1 hover:shadow-lg dark:bg-gray-800"
    *ngFor="let appt of items" (click)="onClick(appt)"
  >
    <!-- Top date and menu dots -->
    <div class="flex justify-between items-center mb-3 text-gray-500  text-[0.85rem] font-medium">
      <span>📓 &nbsp;{{ appt.date| date: 'MMM d, yyyy' }}</span>  <!-- Example: Feb 16, 2025 -->
      <span class="cursor-pointer">•••</span>
    </div>

    <!-- Status with colored dot and title -->
    <div class="flex items-center gap-2 mb-1">
      <span 
        class="w-3 h-3 rounded-full"
        [ngClass]="{
          'bg-yellow-400': appt.status.toLowerCase() === 'inprogress',
          'bg-[#007aff]': appt.status.toLowerCase() === 'upcoming',
          'bg-[#34c759]': appt.status.toLowerCase() === 'completed',
          'bg-[#ff3b30]': appt.status.toLowerCase() === 'cancelled'
        }"
      ></span>
      <span class="text-yellow-600 font-semibold text-sm capitalize">{{ appt.status }}</span>
    </div>

    <!-- Title -->
    <h3 class="text-[1rem] font-semibold  mb-2">{{ appt.title }}</h3>

    <!-- Date & Time with icon -->
    <div class="flex items-center gap-2 text-gray-600 dark:text-gray-300 text-[0.9rem]">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-gray-400 dark:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>{{ appt.date }}, {{ appt.time }}</span>
    </div>



    
  </div>
</div>





